import React from 'react';

import { usePathParam } from 'react-resource-router';

import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/analytics-bridge';
import { ResponderNamesWrapper } from '@atlassian/eoc-responder-names';
import { routingRulesResource } from '@atlassian/eoc-routing-rules/resources';
import { useResource } from '@atlassian/eoc-rrr-helpers';

import EscalationPolicies from './escalation-policies';

export default function TeamEscalationPolicies() {
	const [teamId] = usePathParam('teamId');
	const { loading, error } = useResource(routingRulesResource);

	if (loading) {
		return <UFOLoadHold name="eoc-escalation-policies-loading" />;
	}

	if (error) {
		return null;
	}

	return (
		<ContextualAnalyticsData
			tags={['on-call', 'escalation-policy', 'team-escalations']}
			sourceType={SCREEN}
			sourceName="OnCall"
			objectId={teamId}
			objectType="escalationPolicy"
		>
			<ResponderNamesWrapper>
				<EscalationPolicies />
			</ResponderNamesWrapper>
		</ContextualAnalyticsData>
	);
}
